"use strict";

var Backbone = require("backbone");
var _ = require("underscore");
var $ = require("jquery");
var STR = require("../strings");
var jwt_decode = require("jwt-decode");

Backbone.$ = $;

var debug = require("debug")("views:ReaderView"); //https://github.com/visionmedia/debug

// init handlebars
var hbs = require("handlebars/runtime")["default"]; // https://github.com/wycats/handlebars.js
window.Handlebars = hbs;
Handlebars.$ = $; // pour que handlebars puisse utiliser underscore et jquery
Handlebars._ = _;

// From pv5js
var DocumentModel = require("../models/bnd-document-model");
var PrintQuotaModel = require("@immanens-com/pv5js/reader/models/print-quota-model");
var PrintPasswordModel = require("@immanens-com/pv5js/reader/models/print-password-model");
var DocumentView = require("@immanens-com/pv5js/reader/views/document-view");
var StringUtil = require("@immanens-com/pv5js/common/utils/string-util");
var OverlayLinksView = require("@immanens-com/pv5js/reader/views/overlay-links-view");
var quota = require("@immanens-com/pv5js/reader/lib/quota");
var PageSliderView = require("@immanens-com/pv5js/reader/views/page-slider-view");

var OverlayBarcodeView = require("@immanens-com/pv5js/reader/views/overlay-barcode-view");
var OverlaySelectView = require("@immanens-com/pv5js/reader/views/overlay-select-view");
var SearchInputView = require("@immanens-com/pv5js/search/views/search-input-view");
var BufferScramble = require("@immanens-com/pv5js/reader/lib/buffer-scramble");
var TokenUserPrintModel = require("@immanens-com/pv5js/reader/models/token-user-print-model");
var ThumbnailsView = require("@immanens-com/pv5js/reader/views/thumbnails-view");
var BookmarksModel = require("@immanens-com/pv5js/reader/models/bookmarks-model");

var ThemeLoaderBw = require("../utils/theme-loader-bw");

// From project
var ModalView = require("./modal-view");
var PrintPasswordView = require("./print-password-view");
var BookmarksView = require("./bookmarks-view");
var BndPageQueryModel = require("../models/bnd-page-query-model");
var OverlayBndSearchView = require("../views/overlay-bnd-search-view");

var templates = {
    reader: require("../templates/reader-template.html"),
    page: require("../templates/page-template.html"),
    pageSliderKnob: require("../templates/page-slider-knob-template.html"),
    pageSliderThumb: require("../templates/page-slider-thumb-template.html"),
    pageAuthorization: require("../templates/page-authorization-template.html"),
    thumbnail: require("../templates/thumbnails-template.html"),
    thumbnailCell: require("../templates/thumbnails-cell-template.html")
};

/**
 */
module.exports = Backbone.View.extend({

    app: null, // store a reference to global app (mainly for configuration access)
    documentId: 0, //
    publicationId: 0, //
    page: 1, // starting page
    zoomFav: 1,
    fontSize: 15,
    minFontSize: 10,
    maxFontSize: 20,
    className: "app-reader",
    routeTemplate: "<%=publicationId%>/<%=documentId%>/<%=page%>",
    menuDisplayed: false,
    printQuota: null,
    sidePanel: false,
    mode: "page",
    scrollbarWidth: 0,
    isPhone: false,
    allowText: false,
    selectOverlayStatus: false,
    copyPasteMode: false,
    printCrypted: false,
    chunkSize: 1024,
    rangeSize: 256 * 1024,
    authorizedPages: null,
    displayQuality: "auto",
    webClipper: false, // affichage de l'entrée webclipper dans le menu
    bandwidth: 0,
    vectoLoadingTask: null,
    navigationBar: "show", // show/hide
    pageHistory: null,
    isSampler: false,
    displayedMenuLine: null,
    copiedText: null,

    events: {
        "click .tb-right .rbn-full-screen": "onFullscreenClicked",
        "click .tb-right .rbn-page-history": "onPageHistoryClicked",
        "click .tb-right .rbn-zoom-in": "onZoomInClicked",
        "click .tb-right .rbn-zoom-out": "onZoomOutClicked",
        "click .tb-right .rbn-next-page": "onNextPage",
        "click .tb-right .rbn-previous-page": "onPreviousPage",
        "click .tb-right .rbn-thumbnail": "onThumbnailCliked",
        "click .tb-top .rbn-home": "onHomeClicked",
        "click .tb-top .menu": "onMenuClicked",
        "click .tb-top .menu .line .header": "onMenuLineClicked",
        "click .tb-top .menu .print-document": "onPrintClicked",
        "click .tb-top .menu .copy-text": "onCopyClicked",
        "click .tb-top .menu .share-url": "onShareUrlClicked",
        "click #print-text-some-pages": "onPrintFocus",
        "click .tb-top .rbn-shortcut-print": "onShortcutPrintClicked",
        "click .tb-top .rbn-shortcut-search": "onShortcutSearchClicked",
        "click .tb-top .rbn-shortcut-copy": "onShortcutCopyClicked",
        "click .tb-top .rbn-shortcut-share": "onShortcutShareClicked",
        "click .tb-bottom .toc": "onTocClicked",
        "click .result .search-next": "onNextResult",
        "click .result .search-previous": "onPreviousResult",
        "click .tb-top .menu .refresh": "onRefreshClicked",
        "change .tb-top .menu #pref-display": "onPrefDisplayChanged",
        "change .tb-top .menu #pref-navigation": "onPrefNavigationChanged",
        "submit .tb-bottom .rbn-page-edit-form": "onPageEditSubmited",
        "click .side-panel .rbn-bookmarks-close": "onBookmarksCloseClicked",
        "click .tb-top .menu .search-go": "onSubmitSearch"
    },

    subViews: null, // array of subviews
    overlayViews: null, // array of page overlay views

    /**
     * @param  {Object} options must contains an "app" object and "query" from url
     */
    initialize: function (options) {
        var T = this;

        _.extend(T, options);

        T.eventSignature = "ev-reader-bnd";

        T.subViews = [];
        T.overlayViews = []; // page overlays
        T.modalView = null;

        T.langs = [];
        T.pageHistory = [];

        T.routeTemplate = _.template(T.routeTemplate); // compile route template
        T.template = _.template(templates.reader); // compile template

        // gestion globale des erreurs d'accès aux données
        $.ajaxSetup({
            statusCode: {
                401: function () {
                    if (T.app.token) {
                        if (T.app.onTokenExpired) {
                            T.app.onTokenExpired(T.app, T.app.token); // gestion de l'expiration du token par le front react
                        }
                        else {
                            // le token est tombé, on informe l'utilisateur et on recharge la page
                            T.notify({
                                text: STR.token_lost,
                                type: "error",
                                timeout: 3000
                            });
                            // et on recharge la page ?
                            setTimeout(function () {
                                window.location.reload(false);
                            }, 3000);
                        }
                    }
                },
                403: function () {
                    if (T.app.token && this.url.indexOf("print") == -1) {
                        // le token n'est pas correct pour ce document, on informe l'utilisateur seulement ... certainement qu'il faudrait retourner à la bibliothèque ?
                        T.notify({
                            text: STR.token_error,
                            type: "error",
                            timeout: 3000
                        });
                    }
                }
            }
        });

        // settings
        T.readSettings();
        $(window).on("unload." + T.eventSignature + " pagehide." + T.eventSignature, function () {
            // pagehide est nécessaire pour ios safari car unload n'est envoyé que dans certaines circonstances (https://webkit.org/blog/516/webkit-page-cache-ii-the-unload-event/)
            // dans le cas de chrome qui supporte unload et pagehide, writesettings sera appelé 2 fois ... mais pas grave
            T.writeSettings();
        });

        // fullscreen
        $(document).on("webkitfullscreenchange." + T.eventSignature + " mozfullscreenchange." + T.eventSignature + " fullscreenchange." + T.eventSignature + " MSFullscreenChange." + T.eventSignature, function (e) {
            T.onFullscreenChanged(e);
        });

        if (T.app.token) {
            var decoded = jwt_decode(T.app.token);

            debug("token :", decoded);
            T.printQuota = decoded.printQuota || decoded.pqu;
            T.allowText = decoded.ate;
            T.webClipper = decoded.wcl;
            if (decoded.bcd) {
                T.barcode = String(decoded.bcd);
                if (T.barcode.length < 12) {
                    T.barcode = "0".repeat(12 - T.barcode.length) + T.barcode; // ean13, 12 caractères, sinon on pad
                }
            }
            T.printCrypted = decoded.pro == "c" ? true : false;
            if (decoded.aup) {
                T.authorizedPages = quota.pagesFromString(decoded.aup, Number.MAX_VALUE, ";");
            }
        }

        //T.printQuota = "10/1w"; // debug simulate quota
        //T.printQuota = "0"; // debug simulate infinite quota
        T.allowText = 1; // debug simulate copy paste
        //T.printCrypted = true; // debug print pdf with password
        //T.authorizedPages = quota.pagesFromString("1;2-5;20", Number.MAX_VALUE, ";"); // debug partial access
        //T.webClipper = 1;
        //T.barcode = "123456789012";

        if (_.isArray(T.authorizedPages)) {
            T.isSampler = true;
        }

        // recherche dans le document entier, pour savoir dans quelle page chercher.
        // la taille du résultat sera configuré quand on aura récupéré le nombre de pages du document
        T.documentQueryModel = new BndPageQueryModel({
            filters: {
                documentUid: [T.publicationId + "_" + T.documentId]
            },
            source: ["number"],
            highlight: false,
            sort: "number" // sort by page number
        }, {
            pv5api: T.app.pv5api,
            token: T.app.token
        });
        T.listenTo(T.documentQueryModel, "sync", T.onDocumentSearchEnd);
        T._pageQueryModels = []; // search queries for each page

        T.documentModel = new DocumentModel({
            id: T.documentId,
            publicationId: T.publicationId
        }, {
            pv5api: T.app.pv5api,
            token: T.app.token
        });

        T.printQuotaModel = new PrintQuotaModel({
        }, {
            pv5api: T.app.pv5api,
            token: T.app.token
        });
        T.listenTo(T.printQuotaModel, "sync", T.onPrintQuotaLoaded);

        // DOCUMENT VIEW
        T.documentView = new DocumentView({
            model: T.documentModel,
            pageTemplate: templates.page,
            pageAuthorizationTemplate: templates.pageAuthorization,
            pageAuthorizationMessage: T.app.authorizationMessage || STR.default_content_auth_message,
            zoomMax: 2,
            zoomFav: T.zoomFav,
            zoomStepMultiplier: 1.4,
            tileHd: true,
            authorizedPages: T.authorizedPages
        });
        T.listenTo(T.documentView, "add:page-view", T.onPageViewAdded);
        T.listenTo(T.documentView, "render:page-view", T.onPageViewRendered);
        T.listenTo(T.documentView, "remove:page-view", T.onPageViewRemoved);
        T.subViews.push(T.documentView);

        // page thumbnail slider view
        T.pageSliderView = new PageSliderView({
            model: T.documentModel,
            templateKnob: templates.pageSliderKnob,
            templateThumb: templates.pageSliderThumb,
            authorizedPages: T.authorizedPages,
            fixedWidth: 30,
            usePageLabel: true
        });
        T.listenTo(T.pageSliderView, "drag:end", T.onSliderDragEnded);
        T.listenTo(T.pageSliderView, "click", T.onSliderClicked);
        T.subViews.push(T.pageSliderView);

        // mosaïque de vignettes
        T.thumbnailsView = new ThumbnailsView({
            model: T.documentModel,
            authorizedPages: T.authorizedPages,
            STR: STR,
            template: templates.thumbnail,
            templateCell: templates.thumbnailCell,
            usePageLabel: true
        });
        T.listenTo(T.thumbnailsView, "click", T.onThumbnailsClicked);
        T.subViews.push(T.thumbnailsView);

        T.bookmarksModel = new BookmarksModel({
            documentId: T.documentId,
            publicationId: T.publicationId
        }, {
            pv5api: T.app.pv5api,
            token: T.app.token
        });
        T.bookmarksView = new BookmarksView({
            STR: STR,
            model: T.bookmarksModel,
            nbVisibleLevels: 2
        });
        T.listenTo(T.bookmarksView, "click", T.onBookmarkClicked);
        T.subViews.push(T.bookmarksView);


        T.pageTermsView = new SearchInputView({
            model: T.documentQueryModel,
            fieldName: "query"
        });
        T.listenTo(T.pageTermsView, "submit", T.onSubmitSearch);
        T.subViews.push(T.pageTermsView);

        $(document).on("keydown." + T.eventSignature, function (e) {
            T.onKeyDown(e);
        });
        $(document).on("keyup." + T.eventSignature, function (e) {
            T.onKeyUp(e);
        });

        $(document).on("webclipperopen." + T.eventSignature, function (e) {
            T.onWebClipperOpen(e);
        });
        $(document).on("webclipperclose." + T.eventSignature, function (e) {
            T.onWebClipperClose(e);
        });

        T.listenTo(T.app, "app:notify", T.notify);

        T.listenTo(T.documentModel, "change:page", T.onPageChanged);// seul l'appel à documentView.gotoPage écrit la valeur dans ce modèle

        if (T.app.theme) {
            T.themeLoader = new ThemeLoaderBw({
                api: T.app.themeApi,
                id: T.app.theme,
                version: T.app.themeVersion,
                cacheBreaker: Date.now(),
                useTemplate: false
            });
            T.listenToOnce(T.themeLoader, "sync", T.onThemeLoaded);
            T.themeLoader.fetch();
        }
        else {
            // on ne charge pas de theme, cas kioskjs qui charge déjà un theme avec les styles  du reader
            T.onThemeLoaded(); // TODO voir si c'est toujours utilisé ? si oui il ne peut pas y avoir de test de bande passante
        }

        $(window).on("resize." + T.eventSignature, function () {
            T.onResize();
        });

    },

    onResize: function () {
        var T = this;

        T.checkPhone();
        T.$el.toggleClass("phone", T.isPhone);

        T.pageSliderView.resize();
        T.documentView.resize();

        T.thumbnailsView.onResize();

    },

    writeSettings: function () {
        var T = this,
            settings = {
                zoomFav: T.documentView.zoomFav,
                isFirstTime: false,
                displayQualityBis: T.displayQuality,
                navigationBar: T.navigationBar
            };
        localStorage.setItem("reader-settings", JSON.stringify(settings));
    },

    readSettings: function () {
        var T = this,
            settings = JSON.parse(localStorage.getItem("reader-settings"));
        if (settings) {
            T.zoomFav = settings.zoomFav || T.zoomFav;
            T.displayQuality = settings.displayQualityBis || "auto";
            T.navigationBar = settings.navigationBar || "show";
            if (!_.isUndefined(settings.isFirstTime)) {
                T.isFirstTime = settings.isFirstTime;
            }
        }
    },

    onThemeLoaded: function (e) {
        // load document
        var T = this;
        if (e) {
            T.bandwidth = e.bandwidth;
            debug("bandwidth: " + T.bandwidth + " Mbits/s");
        }
        T.render(); // on ne fait le rendu final que quand le theme est chargé
        T.listenToOnce(T.documentModel, "sync", T.onDocumentLoaded);
        T.documentModel.fetch({
            error: function () {
                T.notify({
                    text: STR.document_not_found,
                    type: "error",
                    timeout: 4000
                });
            }
        });
    },

    onDocumentLoaded: function () {
        var T = this;

        T.tealiumDocumentRef = {
            /*publication_title: T.documentModel.get("publicationTitle"),
            document_title: T.documentModel.get("title"),
            document_number: T.documentModel.get("id"),
            release_date: T.documentModel.get("published"),
            category: T.app.googleAnalytics.category,
            user_type: T.app.googleAnalytics.userType,
            user_ref: T.app.googleAnalytics.userRef,
            bandwidth: T.bandwidth*/
        };

        //T.track("open-reader");
        var server_pdf_max_pages = T.documentModel.get("serverPdfMaxPages");
        if (T.documentModel.get("nbPages") > server_pdf_max_pages) {
            // supprime la possibilité d'imprimer toutes les pages si le serveur ne le permet pas
            T.$("label[for='print-pdf-document']").remove();
            T.$(".server_pdf_max_pages").text(STR.server_pdf_max_pages(server_pdf_max_pages));
        }

        T.bookmarksModel.mtime = T.documentModel.get("mtime");

        T.updateMetadatas();

        // si le document déclare contenir du xml, chargement du xml et du theme utile
        //T.documentModel.set("reversed", true); //simulate arabic document
        //T.documentModel.set("hasVecto", false); // simulate VEC document

        // si le document est dispo en PDF et que cet platforme supporte le rendu vectoriel et que l'editeur autorise le vectoriel, on charge les libs et on charge le document
        // en mode accès partiel on interdit le vecto
        if (T.app.allowVecto && T.documentModel.get("hasVecto") && T.isPlatformSupportVecto() && (T.displayQuality == "high" || (T.displayQuality == "auto" && T.bandwidth >= T.app.vectoMinimalBandwidth)) && !_.isArray(T.authorizedPages)) {
            // on essaye de charger le premier chunk de pdf
            T.vectoChunk(0, T.rangeSize)
                .then(function (chunk) {
                    T.onFirstVectoLoaded(chunk);
                })
                .catch(function () {
                    // le pdf n'est finalement pas dispo, on switch sur les images
                    T.onDocumentLoadedPart2();
                });
        }
        else {
            T.onDocumentLoadedPart2();
        }
    },

    onFirstVectoLoaded: function (first_chunk) {
        var T = this;

        // ok pour vecto, on charge la lib
        $.getScript(T.app.pv5api + "/app/pdfjs/pdf.min.js", function () {

            pdfjsLib.GlobalWorkerOptions.workerSrc = T.app.pv5api + "/app/pdfjs/pdf.worker.min.js";

            var total = 0;
            var transport = new pdfjsLib.PDFDataRangeTransport(first_chunk.total, first_chunk.data);

            transport.requestDataRange = function (begin, end) {
                debug("request", begin, end, end - begin);
                T.vectoChunk(begin, end)
                    .then(function (chunk) {
                        transport.onDataProgress(total);
                        transport.onDataRange(begin, chunk.data);
                        total += (end - begin);
                    })
                    .catch(function (e) {
                        console.error(e);
                    });
            };

            pdfjsLib.getDocument({
                disableRange: false,
                disableStream: true,
                disableAutoFetch: true,
                rangeChunkSize: T.rangeSize,
                range: transport
            }).promise
                .then(function (pdf_document) {
                    T.vectoLoadingTask = pdf_document;
                    T.documentModel.set("pdfDocument", pdf_document);
                    T.onDocumentLoadedPart2();
                })
                .catch(function (e) {
                    // problème x ou y avec le pdf, on utilise les tuiles d'image sans avertir l'utilisateur
                    debug("PDF error, switching to tiles", e);
                    T.onDocumentLoadedPart2();
                });


        });
    },

    onDocumentLoadedPart2: function () {
        var T = this;

        T.track("open-reader");

        T.documentQueryModel.set("size", T.documentModel.get("nbPages"));
        T.documentView.gotoPage(T.reversePage(T.page), false);

        if (T.app.search && T.app.search.query && !T.isSampler) {
            // si on ouvre sur une page et qu'il y a une recherche valide et qu'on est pas en sampler
            T.documentQueryModel.set(T.app.search);
            T.displayMenu(true);
            T.displayMenuLine("search");
            T.documentQueryModel.search();
        }
    },


    isPlatformSupportVecto: function () {
        var is_ios = (/iPad|iPhone|iPod/.test(navigator.userAgent) ||
            (/Mac/i.test(navigator.userAgent) && navigator.maxTouchPoints > 1)); // à partir de ios 13 safari utilise le user-gent d'un Mac (https://stackoverflow.com/questions/9038625/detect-if-device-is-ios)
        if (/Android|webOS|Opera Mini/i.test(navigator.userAgent) || is_ios) {
            // en 2020, c'est encore trop juste niveau perf, on utilise les tuiles
            return false;
        }
        else {
            return true;
        }
    },

    isPageAuthorized: function (page) {
        var T = this;
        if (_.isArray(T.authorizedPages)) {
            return T.authorizedPages.indexOf(page) != -1;
        }
        else {
            return true;
        }
    },

    vectoChunk: function (begin, end) {
        var T = this;

        return new Promise(function (resolve, reject) {
            var url = T.documentModel.pdfUrl() + "/" + begin + "/" + (end - 1);
            url += "?mt=" + T.documentModel.get("mtime");
            var xhr = new XMLHttpRequest(url);
            xhr.open('GET', url);

            if (T.documentModel.token) {
                xhr.setRequestHeader("x-access-token", T.documentModel.token);
            }
            xhr.responseType = 'arraybuffer';
            xhr.onload = function () {

                // analyse du header content-range pour connaitre la taille totale du fichier
                var content_range = xhr.getResponseHeader('Content-Range');
                var total = 0;
                if (content_range) {
                    //bytes 0-262143/18920469
                    total = Number(_.last(content_range.split("/")));
                }
                else {
                    return reject(new Error("unable to find content-range header"));
                }

                // unscramble
                //console.log("scrambled:", xhr.response.toString());
                var chunk_size = T.chunkSize;
                var range_length = end - begin;
                if (range_length < 4 * chunk_size) {
                    chunk_size = Math.floor(range_length / 4);
                    if (chunk_size < 1) {
                        chunk_size = 1;
                    }
                }

                var seed = Number(String(T.publicationId) + String(T.documentId));
                var data = BufferScramble.unscramble(xhr.response, chunk_size, seed);
                //console.log("unscrambled:", data.toString());
                resolve({ data: data, total: total });
            };
            xhr.onerror = function () {
                reject(new Error("error fetching", begin, end, end - begin));
            };
            xhr.send();
        });
    },

    onPageChanged: function () {
        var T = this;

        T.updateRoute(T.pushRouteInHistory);
        T.pushRouteInHistory = false;

        T.highlightLinksInOverlays();


        T.track("open-page");
    },

    onPageViewAdded: function (page_view) {
        var T = this,
            page = page_view.page;

        if (!T.isPageAuthorized(page)) {
            return;
        }

        var page_model = T.documentModel.getPageModel(page);

        // overlay links
        var overlay_links_view = new OverlayLinksView({
            page: page,
            pageModel: page_model
        });
        T.listenTo(overlay_links_view, "click:link", T.onLinkClicked);
        T.overlayViews.push(overlay_links_view);

        // overlay search
        var page_query_model = new BndPageQueryModel({
            filters: {
                documentUid: [T.publicationId + "_" + T.documentId],
                number: [page]
            },
            highlight: true,
            highlightNumberOfFragments: 100,
            highlightFragmentSize: 100,
            highlightWordPosition: true,
            size: 1
        }, {
            pv5api: T.app.pv5api,
            token: T.app.token,
            page: page // pour la retrouver plus facilement par la suite
        });
        T._pageQueryModels.push(page_query_model);
        var search_view = new OverlayBndSearchView({
            page: page,
            pageModel: page_model,
            queryModel: page_query_model
        });
        T.overlayViews.push(search_view);

        if (T.barcode) {
            var barcode_view = new OverlayBarcodeView({
                page: page,
                pageModel: page_model,
                documentModel: T.documentModel,
                barcode: T.barcode,
                height: 4
            });
            T.overlayViews.push(barcode_view);
        }

        // selection pour copier/coller
        var selection = {};
        if (page == 1 || page == T.documentModel.get("nbPages")) {
            selection.x = 30;
            selection.y = 30;
            selection.width = 40;
            selection.height = 40;
        }
        else if (T.documentView.isPortrait) {
            if (page % 2) {
                // page impaire
                selection.x = 65;
                selection.y = 30;
            }
            else {
                // page paire
                selection.x = 15;
                selection.y = 30;
            }
            selection.width = 20;
            selection.height = 40;
        }
        else {
            // double page
            selection.x = 40;
            selection.y = 30;
            selection.width = 20;
            selection.height = 40;
        }

        var select_view = new OverlaySelectView({
            page: page,
            pageModel: page_model,
            hide: !T.selectOverlayStatus,
            selection: selection
        });
        T.listenTo(select_view, "select:start", T.onSelectStart);
        T.listenTo(select_view, "select:end", T.onSelectEnd);
        T.overlayViews.push(select_view);

        // lancer la recherche que si il le faut pour cette page
        if (T.isResultInPage(page)) {
            if (T.documentQueryModel.get("query")) {
                page_query_model.set("query", T.documentQueryModel.get("query"));
                page_query_model.search();
            }
        }

    },

    onPageViewRendered: function (page_view) {
        var T = this;

        if (!T.isPageAuthorized(page_view.page)) {
            return;
        }

        if (page_view.model.fetched) {
            var overlay_views = _.where(T.overlayViews, {
                page: page_view.page
            });

            overlay_views.forEach(function (overlay_view) {
                page_view.$tileContainer.append(overlay_view.el);
            });
        }
    },

    onPageViewRemoved: function (page_view) {
        var T = this;

        if (!T.isPageAuthorized(page_view.page)) {
            return;
        }

        T._pageQueryModels = _.difference(T._pageQueryModels, _.where(T._pageQueryModels, {
            page: page_view.page
        }));

        if (page_view.model.fetched) {
            var overlay_views = _.where(T.overlayViews, {
                page: page_view.page
            });
            overlay_views.forEach(function (overlay_view) {
                overlay_view.remove();
                T.stopListening(overlay_view);
                overlay_view.close();
            });
            T.overlayViews = _.difference(T.overlayViews, overlay_views);
        }
    },

    onLinkClicked: function (overlay_view, url) {
        var T = this;
        if (url) {
            var url_lower = url.toLowerCase();
            if (url_lower.indexOf("page:") === 0) {
                // url goto de sommaire
                var page = parseInt(url.substr(5), 10);
                T.track("inlink", page);
                T.documentView.gotoPage(page, true);
                T.pushRouteInHistory = true;
            } else if (url_lower.indexOf("mailto:") === 0) {
                // adresse mail
                window.location.href = url;
            } else {
                // site web
                if (!(url_lower.indexOf("http://") === 0 || url_lower.indexOf("https://") === 0)) {
                    // si l'url ne commence ni par http ni par https
                    url = "http://" + url;
                }

                window.open(url);
                T.track("outlink", url);
            }
        }
    },

    /**
     * détermine si l'espace dévolu au reader ressemble à un environnement smartphone
     * @return {Boolean} [description]
     */
    checkPhone: function () {

        this.isPhone = this.$el.width() <= 480 ? true : false;
        //return $(window).width() <= 480 ? true : false;
    },

    highlightLinksInOverlays: function () {
        var T = this;

        var page = T.documentModel.get("page");
        if (page > 1 && !T.documentView.isPortrait) {
            page = page % 2 ? page - 1 : page;
        }

        // highlight de l'entité dans l'overlay
        T.overlayViews.forEach(function (overlay_view) {
            if (overlay_view instanceof OverlayLinksView && overlay_view.page == page) {
                overlay_view.highlight();
            }
        });
    },

    updateRoute: function (push_route_in_history) {
        var T = this;
        var page = T.reversePage(T.documentModel.get("page"));
        var context = {
            publicationId: T.documentModel.get("publicationId"),
            documentId: T.documentModel.get("id"),
            page: page
        };

        T.pushPageHistory(page);

        if (T.app.onPageChanged) {
            T.app.onPageChanged(T.app, context);
        }

        // gestion bouton prev/next page
        T.$(".rbn-previous-page").toggleClass("disabled", page == 1);
        T.$(".rbn-next-page").toggleClass("disabled", page == T.documentModel.get("nbPages"));

        // mise à jour input pour rentrer le numéro de page
        var page_label = T.documentModel.pageLabelFromNumber(page);
        T.$(".rbn-page-edit-input").blur().val(page_label);

        if (T.app.useRouter) {

            var route = T.routeTemplate(context);

            T.app.router.navigate(
                route, {
                trigger: false,
                replace: !push_route_in_history
            }
            );
        }
    },

    updateMetadatas: function () {
        var T = this;
        if (!T.documentModel.fetched) return;
        var final_title = T.documentModel.get("title");
        if (T.documentModel.get("subtitle")) {
            final_title += " • " + T.documentModel.get("subtitle");
        }
        document.title = final_title;
        T.$(".document-title").html(final_title).attr("title", final_title);
        T.$(".rbn-page-edit-max").text(T.documentModel.get("nbPages"));
        T.onResize(); // le nombre de pages peut redimensionner le slider si > 999
    },

    onKeyDown: function (e) {
        var T = this,
            prevent = false,
            isEditing = false;

        if (/input|textarea|select/i.test(e.target.nodeName) || e.target.contentEditable == "true") {
            isEditing = true;
        }

        if (!isEditing) {
            // shortcuts only available if user is not entering text in an input
            if (e.keyCode == 39) {
                //"right" : next page or next article
                T.documentView.gotoPage("next", true);
                T.track("next-page");
                prevent = true;
            } else if (e.keyCode == 37) {
                //"left" : previous page or previous article
                T.documentView.gotoPage("previous", true);
                T.track("previous-page");
                prevent = true;
            } else if (e.keyCode == 9) {
                // tab
                T.onTocClicked();
                prevent = true;
            } else if (e.keyCode == 84 && e.altKey) {
                // alt + t : affiche le texte de la page pour debug
                window.open(T.documentModel.url() + "/page/" + T.documentModel.get("page") + "/text?mt=" + T.documentModel.get("mtime"));
                prevent = true;
            }
            else if (e.keyCode == 17) {
                // ctrl : temporarily disable tool
                T.$(".overlay-select").addClass("inactive");
            }
            /*else if (e.keyCode == 67 && (e.ctrlKey || e.metaKey)) {
                if (T.copyPasteMode) {
                    T.onCopyClicked();
                    prevent = true;
                }
            }*/
            else if (e.keyCode == 70 && (e.ctrlKey || e.metaKey) && !T.isSampler) {
                // ctrl + f
                T.displayMenu(true);
                T.displayMenuLine("search");
                T.$("#search-input-phrase").focus();
                prevent = true;
            }
        }

        if (prevent) {
            e.preventDefault();
        }
    },

    onKeyUp: function (e) {
        var T = this;

        if (e.keyCode == 17) {
            T.$(".overlay-select").removeClass("inactive");
        }
    },

    onWebClipperOpen: function () {
        debug("web clipper open");

    },

    onWebClipperClose: function () {
        debug("web clipper close");
    },


    onSliderDragEnded: function () {
        this.track("use-slider");
    },

    onSliderClicked: function () {
        this.track("use-slider");
    },

    onThumbnailsClicked: function (page) {
        var T = this;
        T.displayMenu(false);
        T.documentView.gotoPage(page, false);
        T.track("click-thumbnails");
    },

    onBookmarkClicked: function (page) {
        var T = this;
        if (T.isPhone) {
            T.displayToc(false);
        }
        T.documentView.gotoPage(page, false);
    },


    displayToc: function (show) {
        var T = this;

        if (show) {
            if (!T.bookmarksModel.fetched && !T.bookmarksModel.fetching) {
                T.bookmarksModel.fetch();
            }
            T.$el.addClass("show-panel");
            T.track("toc-panel");
        }
        else {
            T.$el.removeClass("show-panel");
        }
        T.sidePanel = show;
        T.onResize();
    },


    /**
     * go full screen
     */
    onFullscreenClicked: function () {
        var T = this;

        if (T.isFullscreen()) {
            T.exitFullscreen();
        } else {
            T.track("full-screen");
            T.enterFullscreen(document.body);
        }
    },

    onNextPage: function () {
        var T = this;
        T.documentView.gotoPage("next", true);
        T.track("next-page");
    },

    onPreviousPage: function () {
        var T = this;
        T.documentView.gotoPage("previous", true);
        T.track("previous-page");
    },

    onZoomInClicked: function () {
        var T = this;
        T.documentView.zoom("in", true);
    },

    onThumbnailCliked: function () {
        var T = this;
        T.displayMenu(true);
        T.displayMenuLine("thumbnails");
    },

    onShortcutPrintClicked: function () {
        var T = this;

        if (T.displayedMenuLine == "print") {
            T.displayMenu(false);
        }
        else {
            T.displayMenu(true);
            T.displayMenuLine("print");
        }
    },

    onShortcutSearchClicked: function () {
        var T = this;

        if (T.displayedMenuLine == "search") {
            T.displayMenu(false);
        }
        else {
            T.displayMenu(true);
            T.displayMenuLine("search");
        }
    },

    onShortcutShareClicked: function () {
        var T = this;
        if (T.displayedMenuLine == "share") {
            T.displayMenu(false);
        }
        else {
            T.displayMenu(true);
            T.displayMenuLine("share");
        }
    },

    onBookmarksCloseClicked: function () {
        this.displayToc(false);
    },

    onShortcutCopyClicked: function () {
        var T = this;
        if (T.displayedMenuLine == "copy") {
            T.displayMenu(false);
        }
        else {
            T.displayMenu(true);
            T.displayMenuLine("copy");
        }
    },

    onZoomOutClicked: function () {
        var T = this;
        T.documentView.zoom("out", true);
    },

    onHomeClicked: function () {
        var T = this;

        if (_.isFunction(T.app.onHomeClicked)) {
            T.app.onHomeClicked(T.app);
        }
        else if (T.app.homeUrl) {
            window.location = T.app.homeUrl;
        }
    },

    /**
     * Menu
     */

    onMenuClicked: function (e) {
        var T = this;
        if (!$(e.target).hasClass("menu")) return;
        T.displayMenu(!T.menuDisplayed);
    },

    displayMenu: function (show) {
        var T = this;
        debug("displayMenu", show);
        T.menuDisplayed = show;
        T.$(".tb-top .menu").toggleClass("on", T.menuDisplayed);
        T.$(".tb-top .menu .line .content").hide();
        T.$(".tb-top .menu .line").show();
        T.$(".tb-top .dropdown").removeClass("maximized");

        // disable shortcut on
        this.$(".rbn-shortcut.rbn-on").removeClass("rbn-on");

        if (show) {
            if (T.copyPasteMode) {
                T.enterCopyPasteMode(false);
            }
        }
        else {
            if (T.copyPasteMode) {
                T.enterCopyPasteMode(false);
            }
            if (T.thumbnailsView.enabled) {
                T.thumbnailsView.enable(false);
                T.$(".tb-top .toggle-mode").show();
            }
            T.displayedMenuLine = null;
        }
    },

    onMenuLineClicked: function (e) {
        var T = this;
        e.stopPropagation();

        if (!$(e.target).hasClass("header")) return;
        var action = $(e.target).parent().data("action");
        if (action) {
            T.displayMenuLine(action);
        }
    },

    displayMenuLine: function (action) {
        var T = this;

        if (action == "print" && T.printQuota && T.printQuota.indexOf("/") != -1) {
            // demande de la consommation
            T.printQuotaModel.fetch();
        }

        if (action == "print" || action == "search") {
            T.setMode("page");
        }

        if (action == "copy") {
            T.enterCopyPasteMode(true);
            T.$(".rbn-shortcut-copy").addClass("rbn-on");
            T.copiedText = null;
            T.$(".tb-top .dropdown .copy-text").addClass("disabled");
        }
        else if (action == "print") {
            T.$(".rbn-shortcut-print").addClass("rbn-on");
            T.track("print-panel");
        }
        else if (action == "share") {
            T.$(".rbn-shortcut-share").addClass("rbn-on");
            if (T.app.currentUrl) {
                var page = T.documentModel.get("page");
                var url = T.app.currentUrl(page);
                T.$("#share-url-text").text(url);
            }
            T.selectElementContents(T.$("#share-url-text")[0]);
        }
        else if (action == "search") {
            T.$(".rbn-shortcut-search").addClass("rbn-on");
            T.track("search", "click");
        }


        T.$(".tb-top .menu .line").hide();
        T.$(".tb-top .menu .line[data-action='" + action + "']").show();
        T.$(".tb-top .menu .line[data-action='" + action + "'] .content").show();

        if (action == "thumbnails") {
            T.track("open-thumbnails");
            T.$(".tb-top .dropdown").addClass("maximized");
            var thumbnails_page;
            if (T.mode == "page") {
                thumbnails_page = T.documentModel.get("page");
            }
            else {
                thumbnails_page = Number(T.entityPageLabel(0));
            }
            T.thumbnailsView.enable(true, thumbnails_page);
            T.$(".tb-top .toggle-mode").hide();
        }

        if (action == "search") {
            T.$("#search-input-phrase").focus();

        }
        T.displayedMenuLine = action;

    },

    onPrintFocus: function () {
        this.$("#print-pdf-some-page").prop("checked", true);
    },

    onSelectStart: function () {
        this.$(".tb-top .dropdown").addClass("select");
        this.copiedText = null;
        this.$(".tb-top .dropdown .copy-text").addClass("disabled");
    },

    onSelectEnd: function () {
        this.onCopySelectionEnd();
        this.$(".tb-top .dropdown").removeClass("select");
    },

    onShareUrlClicked: function () {
        var T = this;

        if (!T.app.currentUrl) return;

        var page = T.documentModel.get("page");
        var url = T.app.currentUrl(page);
        T.copyToClipboard(url);
        T.track("share");
    },

    onCopySelectionEnd: function () {
        // get selection
        var T = this;
        if (!T.copyPasteMode) return;

        // recherche de l'overlay courant
        var page = T.documentModel.get("page");
        if (page > 1 && !T.documentView.isPortrait) {
            page = page % 2 ? page - 1 : page;
        }

        T.track("copy");

        var page_model = T.documentModel.getPageModel(page),
            page_width = page_model.get("width"),
            page_height = page_model.get("height"),
            rectangle;


        // recherche de l'overlay de la page courante
        var overlay_views = _.where(T.overlayViews, {
            page: page
        });
        overlay_views.forEach(function (overlay_view) {
            if (overlay_view instanceof OverlaySelectView) {
                rectangle = {
                    left: Math.round(overlay_view.selection.x * page_width / 100),
                    top: Math.round(overlay_view.selection.y * page_height / 100),
                    right: Math.round((overlay_view.selection.x + overlay_view.selection.width) * page_width / 100),
                    bottom: Math.round((overlay_view.selection.y + overlay_view.selection.height) * page_height / 100)
                };
            }
        });

        if (rectangle) {

            // fetch text
            var url = page_model.textUrl(rectangle);
            var options = {
                url: url,
                headers: {
                },
                success: function (text) {

                    if (T.documentModel.get("reversed")) {
                        // on ne supprime pas les saut de ligne pour les documents arabes
                        // eslint-disable-next-line
                        text = text.replace(/[\x00-\x09\x0B\x0C\x0E-\x1F\x7F]/g, "").replace(/\s\s+/g, ' ');
                    }
                    else {
                        // eslint-disable-next-line
                        text = text.replace(/“ /g, "“").replace(/[\x00-\x09\x0B\x0C\x0E-\x1F\x7F]/g, "").replace(/\n/g, " ").replace(/\s\s+/g, ' ');
                    }

                    if (text.length) {
                        debug("clipboard text", text);
                        // enable button
                        T.$(".tb-top .dropdown .copy-text").removeClass("disabled");
                        T.copiedText = text;
                    }
                    else {
                        T.notify({
                            text: STR.copy_no_text,
                            type: "warning",
                            timeout: 4000
                        });
                    }
                },

                error: function (data, statut, erreur) {
                    T.notify({
                        text: erreur + " : " + data.responseJSON.message,
                        type: "error",
                        timeout: 6000
                    });
                }
            };
            if (T.app.token) {
                options.headers["x-access-token"] = T.app.token;
            }
            $.ajax(options);
        }

    },

    onCopyClicked: function (){
        if(this.copiedText){
            this.track("copy");
            this.copyToClipboard(this.copiedText);
        }
    },

    copyToClipboard: function (text) {
        var T = this;

        // sert pour la fonciton sélection de texte et pour la copie du code d'ouverture du pdf

        if (navigator.clipboard) {
            navigator.clipboard.writeText(text).then(function () {
                T.clipboardNotify(true, text);
            }, function () {
                T.clipboardNotify(false, text);
            });
        }
        else {
            // en 2019, la gestion de navigator.clipboard ne fonctionnait pas pour safari, 
            // on utilise la vielle méthode avec le textarea à la place ci-dessous
            var range = document.createRange();

            // from https://stackoverflow.com/questions/34045777/copy-to-clipboard-using-javascript-in-ios
            var textArea = document.createElement("textarea");
            textArea.contentEditable = true;
            textArea.readOnly = false;
            textArea.value = text;
            document.body.appendChild(textArea);

            range.selectNodeContents(textArea);

            var s = window.getSelection();
            s.removeAllRanges();
            s.addRange(range);

            textArea.setSelectionRange(0, 999999);

            var success;
            try {
                success = document.execCommand('copy');
            } catch (e) {
                success = false;
            }
            T.clipboardNotify(success, text);
            document.body.removeChild(textArea);
        }

        // on créé une textarea cachée pour que l'extension web-clipper soit avertie d'une sélection de texte
        if (!T.$selectionEl) {
            T.$selectionEl = $("<textarea/>");
            T.$selectionEl.addClass("web-clipper-selection-text");
            T.$selectionEl.css({ display: "none" });
            T.$el.append(T.$selectionEl);
        }
        T.$selectionEl.val(text);
        T.$selectionEl.select();
        setTimeout(function () {
            T.$selectionEl.blur();
        }, 500);
    },

    clipboardNotify: function (success, text) {
        var T = this;
        if (success) {
            var str = STR.copy_ok;
            if (text) {
                str += " (" + text.substr(0, 20) + (text.length > 20 ? "…" : "") + ")";
            }
            T.notify({
                text: str,
                type: "info",
                timeout: 2000
            });
        } else {
            T.notify({
                text: STR.copy_nok,
                type: "error",
                timeout: 6000
            });
        }
    },

    enterCopyPasteMode: function (enter) {
        var T = this;
        T.copyPasteMode = enter;
        T.displaySelectOverlay(enter);
        T.$(".tb-top .dropdown").toggleClass("copy", enter);
    },

    displaySelectOverlay: function (show) {
        var T = this;
        T.selectOverlayStatus = show;
        T.$(".overlay-select").toggleClass("hide", !show);
    },

    displayPrintPassword: function (print_url, nb_pages) {
        var T = this;

        if (T.modalView) {
            T.modalView.close();
            T.modalView = null;
        }

        //
        var print_password_model = new PrintPasswordModel({
        }, {
            pv5api: T.app.pv5api,
            token: T.app.token
        });

        // affiche la modale qui présente le mot de passe du PDF
        var print_password_view = new PrintPasswordView({
            model: print_password_model,
            onNextCallback: function (pwd, password_token) {
                if (pwd) {

                    var final_print_url = print_url;
                    final_print_url += print_url.indexOf('?') == -1 ? "?" : "&";
                    final_print_url += "passwordToken=" + password_token;
                    window.open(final_print_url);
                    T.track('print', nb_pages);
                    //T.modalView.hide(); // si on cache, ios ne voudra plus ouvrir le lien
                }
            },
            onCopyCodeCallback: function (pwd) {
                if (pwd) {
                    T.copyToClipboard(pwd);
                }
            }

        });

        T.modalView = new ModalView({
            title: null,
            view: print_password_view,
            effect: "fade-in"
        });

        T.modalView.setElement($(".rbn-modal-print-password")).render();

        setTimeout(function () { T.modalView.show(); }, 50);

    },

    onRefreshClicked: function () {
        window.location.reload();
    },

    onPrefDisplayChanged: function () {
        var T = this;
        T.displayQuality = T.$('#pref-display').val();
        T.writeSettings();
    },

    onPrefNavigationChanged: function () {
        var T = this;
        T.navigationBar = T.$('#pref-navigation').val();
        T.writeSettings();

        if (T.navigationBar == "hide") {
            T.$(".tb-right").hide();
        }
        else {
            T.$(".tb-right").show();
        }

    },

    onTocClicked: function () {
        this.displayToc(!this.sidePanel);
    },

    onPageEditSubmited: function (e) {
        var T = this, page_label = T.$(".rbn-page-edit-input").blur().val();

        var page_number = T.documentModel.pageNumberFromLabel(page_label);

        if (page_number) {
            T.documentView.gotoPage(page_number);
            T.track("goto-page");
        }
        else {
            // soit page inconnue, soit page dans le 
            page_number = Number(page_label);
            if (page_number > 0 && page_number <= T.documentModel.get("nbPages")) {
                T.documentView.gotoPage(page_number);
                T.track("goto-page");
            }
            else {
                // notify
                T.notify({
                    text: "Impossible d'aller à la page \"" + page_label + "\"",
                    type: "warning",
                    timeout: 4000
                });
            }
        }
        e.preventDefault();
    },

    onPrintClicked: function (e) {
        var T = this,
            page_str = "1",
            error_str = null,
            need_reverse;

        e.stopPropagation(); // necessaire sur ios en 2019 sinon l'url ne s'ouvrira pas

        var type = T.$("input[name='print-group']:checked").val();
        if (type == "active-page") {
            page_str = T.pageLabel(0);
        } else if (type == "some-pages") {
            page_str = T.$("#print-text-some-pages").val().trim();

            // transforme les pages labels en number dans la string
            page_str = T.documentModel.convertPrintRangeLabel(page_str);

            if (!quota.checkPrintRangeSyntax(page_str, T.documentModel.get("nbPages"))) {
                error_str = STR.wrong_syntax_pages;
            }

            if (T.documentModel.get("reversed")) {
                need_reverse = true; // seule la série rentrée par l'utilisateur à besoin d'être retournée dans le cas d'un document arabe
            }
        }

        var nb_pages = quota.pagesFromString(page_str, T.documentModel.get("nbPages")).length;

        if (nb_pages > T.documentModel.get("serverPdfMaxPages")) {
            error_str = STR.print_quota_exceeded;
        }

        var max_pages = quota.counterFromString(T.printQuota);
        if (max_pages > 0 && T.printQuotaModel.get("counter") + nb_pages > max_pages) {
            error_str = STR.print_quota_exceeded;
        }

        if (T.authorizedPages && _.isArray(T.authorizedPages)) {
            // on checke que les pages demandées sont bien toutes autorisées
            var pages_requested = quota.pagesFromString(page_str, T.documentModel.get("nbPages"));
            var pages_intersection = _.intersection(T.authorizedPages, pages_requested);
            if (pages_intersection.length != pages_requested.length) {
                error_str = STR.print_pages_not_authorized;
            }
        }

        if (!error_str) {

            if (need_reverse) {
                page_str = quota.reversePrintRange(page_str, T.documentModel.get("nbPages"));
            }

            var token_user_print_model = new TokenUserPrintModel({
                documentId: T.documentId,
                publicationId: T.publicationId,
                pages: page_str
            }, {
                pv5api: T.app.pv5api,
                token: T.app.token,
            });

            T.printNbPages = nb_pages;

            T.listenToOnce(token_user_print_model, "sync", T.onTokenUserPrintGenerated);
            token_user_print_model.save();

        } else {
            T.notify({
                text: error_str,
                type: "warning",
                timeout: 8000
            });
        }
    },

    onTokenUserPrintGenerated: function (token_user_print_model) {
        var T = this;
        var url = T.app.pv5api + "/user-print";

        // on ajoute le nom de la publication en fin d'url pour que le titre de l'onglet soit présentable
        var title = STR.print + " : " + T.documentModel.get("publicationTitle");
        title = title.replace(/\//g, ' '); // si par hasard le nom de publication contient un /, sinon la route de pv5 ne sera plus vérifiée

        if (T.documentModel.get("title")) {
            title += " " + T.documentModel.get("title");
        }
        url += "/" + encodeURIComponent(title);

        url += "?lang=" + T.app.lang;

        if (T.app.token) {
            url += "&token=" + token_user_print_model.get("userPrintToken");
        }

        if (T.printCrypted) {
            // on affiche une modal avec un code
            T.displayMenu(false);
            T.displayPrintPassword(url, T.printNbPages);
        }
        else {
            var w = window.open(url); // ouvre le pdf dans un nouvel onglet, impossible d'afficher la boite d'impression directement en 2019
            if (w) {
                w.focus(); // important pour ios
                T.track('print', T.printNbPages);
                T.displayMenu(false);
            }
        }
    },

    pageLabel: function (pad) {
        var T = this;
        var page = T.documentModel.get("page");
        var page_label;
        if (T.documentModel.get("isDouble") && !T.documentView.isPortrait && page > 1 && page < T.documentModel.get("nbPages")) {
            if (page % 2) {
                page_label = StringUtil.pad(page - 1, pad) + "-" + StringUtil.pad(page, pad);
            } else {
                page_label = StringUtil.pad(page, pad) + "-" + StringUtil.pad(page + 1, pad);
            }
        } else {
            page_label = StringUtil.pad(page, pad);
        }
        return page_label;
    },


    track: function (event, arg) {
        var T = this;
        var event_name;

        if (!T.app.onTrackingEvent) return;
        if (!T.documentModel.fetched) return;

        if (event == "toc-panel") {
            event_name = "Sommaire";
        }
        else if (event == "open-thumbnails") {
            event_name = "Mosaique";
        }
        else if (event == "full-screen") {
            event_name = "Plein_ecran";
        }
        else if (event == "use-slider") {
            event_name = "Navigation_rapide";
        }
        else if (event == "next-page") {
            event_name = "Page_suivante";
        }
        else if (event == "previous-page") {
            event_name = "Page_precedente";
        }
        else if (event == "history-back") {
            event_name = "Revenir_sur_la_page_precedente";
        }
        else if (event == "goto-page") {
            event_name = "Aller_a";
        }
        else if (event == "share") {
            event_name = "Copier_url";
        }
        else if (event == "search") {
            if (arg == "click") {
                event_name = "Rechercher";
            }
            else if (arg == "go") {
                event_name = "Voir_les_mots_trouvés";
            }
            else {
                event_name = "Voir_le_mot_suivant";
            }
        }
        else if (event == "print") {
            event_name = "Imprimer";
        }
        else if (event == "copy") {
            event_name = "Copier";
        }

        if (event_name) {
            var document = T.documentModel.toJSON();
            delete (document.pdfDocument);
            T.app.onTrackingEvent(T.app, event_name, document);
        }
    },

    setMode: function (new_mode, options) {
        var T = this,
            page;

        options = options || {};

        if (!options.force && T.mode == new_mode) return;

        T.mode = new_mode;

        if (new_mode == "page") {
            T.$el.addClass("mode-page");
            T.documentView.enable = true;
            T.$(".tb-right").css("right", 0);
            T.documentView.resize();
            T.pageSliderView.resize();
            // recherche de la page correspondant à l'entité en cours
            if (options.page) {
                page = options.page;
            }

            var previous_page = T.documentModel.get("page");

            if (page) {
                T.documentView.gotoPage(page);
                if (page == previous_page) {
                    T.track("open-page");// on fait un tracking ici car le tracking sur page n'est pas déclenché si c'est la même page qui est affichée
                }
            }

        }
        T.track("change-mode");
    },

    /**
     * change button appearance when fullscreen change
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    onFullscreenChanged: function () {
        var T = this,
            fs = T.isFullscreen();

        T.$el.toggleClass("fullscreen", fs);
        T.$(".rbn-full-screen").toggleClass("on", fs); // mettre une class semble le plus stable, les pseudo class ne sont pas comprises par tous les navigateurs en 2015
        T.onResize();
    },

    isFullscreen: function () {
        return (document.fullscreenElement || document.mozFullScreenElement || document.webkitFullscreenElement || document.msFullscreenElement);
    },

    enterFullscreen: function (el) {

        if (el.requestFullscreen) {
            el.requestFullscreen();
        } else if (el.webkitRequestFullscreen) {
            el.webkitRequestFullscreen();
        } else if (el.mozRequestFullScreen) {
            el.mozRequestFullScreen();
        } else if (el.msRequestFullscreen) {
            el.msRequestFullscreen();
        } else {
            throw new Error("Fullscreen not supported");
        }
    },

    exitFullscreen: function () {
        if (document.exitFullscreen) {
            document.exitFullscreen();
        } else if (document.msExitFullscreen) {
            document.msExitFullscreen();
        } else if (document.mozCancelFullScreen) {
            document.mozCancelFullScreen();
        } else if (document.webkitExitFullscreen) {
            document.webkitExitFullscreen();
        }
    },


    /**
     * Display a sliding message from bottom
     * @param  {Object} data
     * {
     *      text:text,
     *      type:"error", //"error","info"
     *      timeout:10000
     *  }
     */
    notify: function (data) {
        var T = this;

        if (T.notifyTimer) {
            clearTimeout(T.notifyTimer);
        }

        T.$(".notify").addClass("show");
        T.$(".notify > p").attr("class", data.type).html(data.text);

        if (data.timeout) {
            T.notifyTimer = setTimeout(function () {
                T.notifyClose();
                T.notifyTimer = 0;
            }, data.timeout);
        }

    },

    notifyClose: function () {
        this.$(".notify").removeClass("show");
    },

    render: function () {
        var T = this;

        if (T.themeLoader && !T.themeLoader.fetched) return T;

        debug("render");

        var context = {
            STR: STR,
            webClipperMessage: T.app.webClipperMessage,
            fullscreenEnabled: document.fullscreenEnabled || document.mozFullscreenEnabled || document.webkitFullscreenEnabled || document.msFullscreenEnabled
        };

        T.$el.html(T.template(context));
        T.$switchArticle = T.$(".switch-article");

        T.assign(T.documentView, ".document-view");
        T.assign(T.pageSliderView, ".page-slider");
        T.assign(T.thumbnailsView, ".line[data-action='thumbnails'] .content");
        T.assign(T.pageTermsView, "#search-input-phrase");
        T.assign(T.bookmarksView, ".rbn-bookmarks-view");


        T.$(".version").html(T.app.version);

        if (_.isUndefined(T.printQuota) || _.isNull(T.printQuota) || T.printQuota == "-1") {
            T.$(".line[data-action='print']").remove();
            T.$(".rbn-shortcut-print").remove();
        }
        else if (T.printQuota == "0") {
            // impression sans limites
            T.$(".line[data-action='print'] .quota").remove();
        }
        else {
            // impression avec quota
            T.renderQuota();
        }

        if (!T.allowText) {
            T.$(".line[data-action='copy']").remove();
            T.$(".rbn-shortcut-copy").remove();
        }


        if (T.navigationBar == "hide") {
            T.$(".tb-right").hide();
        }

        if (T.isSampler) {
            // on cache tout ce qui est recherche/impression/copier-coller/partage/mosaique/historique
            T.$(".line[data-action='search']").remove();
            T.$(".rbn-shortcut-search").remove();
            T.$(".line[data-action='print']").remove();
            T.$(".rbn-shortcut-print").remove();
            T.$(".line[data-action='copy']").remove();
            T.$(".rbn-shortcut-copy").remove();
            T.$(".line[data-action='share']").remove();
            T.$(".rbn-shortcut-share").remove();
            T.$(".line[data-action='thumbnails']").remove();
            T.$(".button.rbn-thumbnail").remove();
            T.$(".button.rbn-page-history").remove();

            // on ajoute un style global pour des ajustement en mode sampler (position zappette qui a moins de boutons par exemple)
            T.$el.addClass("sampler");
        }

        // preferences
        T.$('#pref-display option[value="' + T.displayQuality + '"]').prop('selected', true);
        T.$('#pref-navigation option[value="' + T.navigationBar + '"]').prop('selected', true);

        T.setMode(T.mode, { force: true });
        T.onResize();

        return T;
    },

    /**
     * remplit les valeurs de quota dans la boite d'impression
     */
    renderQuota: function () {
        var T = this;
        if (!T.printQuota) return;
        var nb_pages = quota.counterFromString(T.printQuota);
        var period = quota.periodFromString(T.printQuota);

        var unit = period.slice(-1);
        var unit_str;
        var number_of_unit = parseInt(period.substr(0, period.length - 1));

        unit_str = STR["print_period_" + unit + (number_of_unit > 1 ? "_plurial" : "")];

        var str_quota = "";

        // analyse de la période
        //str_quota = nb_pages + " pages par période de " + number_of_unit + " " + unit_str;
        str_quota = STR.print_quota_rule(nb_pages, number_of_unit + " " + unit_str);
        T.$("#quota-value").html(str_quota);
    },

    onPrintQuotaLoaded: function () {
        var T = this;
        T.$("#counter-value").html(STR.print_counter(T.printQuotaModel.get("counter")));
        T.$("#reset-value").html(new Date(T.printQuotaModel.get("resetAt")).toLocaleString());
    },

    computeScrollbarWidth: function () {
        var T = this;
        var $scroll_div = $("<div/>");
        $scroll_div.addClass("scrollbar-measure");
        T.$el.append($scroll_div);

        // Get the scrollbar width
        T.scrollbarWidth = $scroll_div[0].offsetWidth - $scroll_div[0].clientWidth;
        debug("scrollbar width:", T.scrollbarWidth); // Mac:  15

        // Delete the DIV 
        $scroll_div.remove();
    },

    /**
     * si le document est de type arabe, inverse la numérotation (fonctionne dans les 2 sens, reversed->original et original->reversed)
     */
    reversePage: function (page) {
        var T = this;
        if (T.documentModel.get("reversed")) {
            page = T.documentModel.get("nbPages") - page + 1;
        }
        return page;
    },

    /**
     * si le document est de type arabe, inverse la numérotation utilisée pour le tracking
     * @param {String} page_label "1" ou "2-3"
     */
    reversePageLabel: function (page_label) {
        var T = this;
        if (T.documentModel.get("reversed")) {
            var nb_pages = T.documentModel.get("nbPages");
            var page_label_spl = page_label.split("-");
            if (page_label_spl.length == 1) {
                var page = parseInt(page_label_spl[0]);
                page_label = String(nb_pages - page + 1);
            } else if (page_label_spl.length == 2) {
                var page_min = parseInt(page_label_spl[0]);
                var page_max = parseInt(page_label_spl[1]);
                page_label = String(nb_pages - page_max + 1) + "-" + String(nb_pages - page_min + 1);
            }
        }
        return page_label;
    },

    /**
     * Initiate a search in document from panel
     */
    onSubmitSearch: function () {
        var T = this;

        // reset all search query and overlays
        T.resetPageQuery();

        // disable next / prev button
        T.enableResultButtons(false);

        // initiate a new search in document if request is not empty
        if (T.documentQueryModel.get("query")) {

            T.$(".search-msg").text(STR.search_in_progress);

            T.documentQueryModel.search({
                error: function () {
                    T.$(".search-msg").text(STR.search_error);
                }
            });

            T.track("search", "go");
        }

    },

    /**
     * Disable/enable prev/next result  button
     * @param  {Bool} enable
     */
    enableResultButtons: function (enable) {
        var T = this;
        T.$(".content > .result").toggleClass("enable", enable);
    },


    onDocumentSearchEnd: function () {
        var T = this,
            hits = T.documentQueryModel.get("hits");

        var terms = "";
        if (T.documentQueryModel.get("query")) {
            terms += T.documentQueryModel.get("query");
        }

        if (hits.length) {
            T.notifyClose();
            _.each(T._pageQueryModels, function (page_query_model) {
                if (T.isResultInPage(page_query_model.page)) {
                    page_query_model.set("query", T.documentQueryModel.get("query"));
                    page_query_model.search();
                }
            });

            T.$(".search-msg").text(STR.search_found(terms, hits.length));
            T.enableResultButtons(true);

            //go to the first result
            T.gotoResult("nearest");
        } else {
            T.$(".search-msg").text('"' + terms + '"' + STR.search_not_found);
        }
    },

    /**
     * Reset page search queries and overlays
     */
    resetPageQuery: function () {
        var T = this;

        T.documentQueryModel.fetched = false;

        _.each(T._pageQueryModels, function (page_query_model) {
            page_query_model.fetched = false;
        });

        _.each(T.overlayViews, function (overlay_view) {
            if (overlay_view instanceof OverlayBndSearchView) {
                overlay_view.render();
            }
        });
    },

    /**
     * Determine if page is in result collection
     * @param  {Number}  p [description]
     * @return {Boolean}   [description]
     */
    isResultInPage: function (p) {
        var T = this,
            hits = T.documentQueryModel.get("hits"),
            found = false;

        if (T.documentQueryModel.fetched && hits.length) {
            hits.all(function (hit) {
                var page = hit.get("source").number[0];
                if (page == p) {
                    found = true;
                    return false;
                }
                return true;
            });
        }

        return found;
    },

    /**
     * Goto result, change page if needed
     * @param  {String} mode nearest, previous, next
     */
    gotoResult: function (mode) {
        var T = this,
            current_page = T.documentModel.get("page"),
            nearest_page = 0,
            results = T.documentQueryModel.get("hits"),
            result_index,
            results_reversed;

        if (T.documentQueryModel.fetched && results.length) {
            if (mode == "nearest") {
                // presque comme next et previous sauf qu'on regarde aussi dans la page courante
                if (T.documentModel.get("reversed")) {
                    // gestion doc reversed, on part de la fin et on remonte pour trouver la page la plus proche
                    results_reversed = results.first(results.length).reverse();
                    _.all(results_reversed, function (result) {
                        var page = result.get("source").number[0];
                        if (page <= current_page) {
                            nearest_page = page;
                            result_index = results.indexOf(result);
                            return false;
                        }
                        return true;
                    });
                    if (!nearest_page) {
                        result_index = results.length - 1;
                        nearest_page = results.last().get("source").number[0];
                    }
                }
                else {
                    results.all(function (result) {
                        var page = result.get("source").number[0];
                        if (page >= current_page) {
                            nearest_page = page;
                            result_index = results.indexOf(result);
                            return false;
                        }
                        return true;
                    });
                    if (!nearest_page) {
                        result_index = 0;
                        nearest_page = results.first().get("source").number[0];
                    }
                }
            } else if (mode == "next") {
                results.all(function (result) {
                    var page = result.get("source").number[0];
                    if (page > current_page) {
                        nearest_page = page;
                        result_index = results.indexOf(result);
                        return false;
                    }
                    return true;
                });
                if (!nearest_page) {
                    result_index = 0;
                    nearest_page = results.first().get("source").number[0];
                }
            } else if (mode == "previous") {
                results_reversed = results.first(results.length).reverse();
                _.all(results_reversed, function (result) {
                    var page = result.get("source").number[0];
                    if (page < current_page) {
                        nearest_page = page;
                        result_index = results.indexOf(result);
                        return false;
                    }
                    return true;
                });
                if (!nearest_page) {
                    result_index = results.length - 1;
                    nearest_page = results.last().get("source").number[0];
                }
            }

            if (nearest_page) {
                if (T.documentModel.get("reversed")) {
                    result_index = results.length - result_index - 1;
                }
                T.$(".search-index").text((result_index + 1) + " / " + results.length);
                if (nearest_page != current_page) {
                    T.documentView.gotoPage(nearest_page, true);// on va à la page
                }
            }
        }
    },

    onNextResult: function () {
        var T = this,
            direction = T.documentModel.get("reversed") ? "previous" : "next";

        T.gotoResult(direction);
        T.track("search", "next");
    },

    onPreviousResult: function () {
        var T = this,
            direction = T.documentModel.get("reversed") ? "next" : "previous";

        T.gotoResult(direction);
        T.track("search", "previous");
    },

    pushPageHistory: function (page) {
        var T = this;
        T.$(".rbn-page-history").toggleClass("disabled", this.pageHistory.length == 0);
        T.pageHistory.push(page);
    },

    onPageHistoryClicked: function () {
        var T = this;
        if (this.pageHistory.length < 2) {
            return;
        }
        T.pageHistory.pop();
        var page = T.pageHistory.pop();
        T.track("history-back");
        T.documentView.gotoPage(page);
    },

    selectElementContents: function (el) {
        var range = document.createRange();
        range.selectNodeContents(el);
        var sel = window.getSelection();
        sel.removeAllRanges();
        sel.addRange(range);
    },

    /**
     * close each sub view and stop listening
     */
    close: function () {
        var T = this;

        T.writeSettings();

        T.subViews.forEach(function (view) {
            view.close();
        });
        T.subViews = null;
        T.overlayViews = null;
        T.$selectionEl = null;

        if (T.modalView) {
            T.modalView.close();
            T.modalView = null;
        }

        if (T.themeLoader) {
            T.themeLoader.close();
        }

        if (T.vectoLoadingTask) {
            T.documentModel.set("pdfDocument", null);
            T.vectoLoadingTask.destroy();
            T.vectoLoadingTask = null;
        }

        $.ajaxSetup({
            statusCode: {
                401: null,
                403: null
            }
        });

        $(document).off("." + T.eventSignature);
        $(window).off("." + T.eventSignature);

        T.stopListening();
        T.undelegateEvents();

        T.$el.empty();
    }

});


//////////////////
// WEBPACK FOOTER
// ./src/views/reader-view.js
// module id = 17
// module chunks = 0